import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../services/core/authentication.service';
import { AppService } from '../../services/app.service';
import { ApiConnectionService } from '../../services/core/api-connection.service';
import { CollectionManagerService } from '../../services/core/collection-manager.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfigService } from '../../services/core/config.service';

import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-sections-index',
	templateUrl: './sections.component.html',
	styleUrls: ['./sections.component.scss']
})
export class SectionsIndexComponent implements OnInit {
	sections: any = [];
	currentUser;
	topSections: any = [];
	bottomSections: any = [];
	highlight: any = '';
	introText: any = '';
	introImage: string = '';
	cdnUrl = ''
	systemTitle = ''
	systemSlogan = ''
	systemKey = ''
	salesWebsite = ''
	sectionIntro = ''
	topSectionsIsLoaded = false;
	frontType = 'DEFAULT';
	frontTypeChapter;

	fetchedContent = false;
	electives = [];
	choiceAssignments = [];
	bottomExtra = [];

	highlightLessons: any = [];

	activeChapterIds = [];
	checkLicense = false;
	banner = null;

	youtubeEmbedSafeURL = null;


	constructor(
		public appService: AppService,
		public apiConnectionService: ApiConnectionService,
		public authenticationService: AuthenticationService,
		public collectionManager: CollectionManagerService,
		private ngxLoader: NgxUiLoaderService,
		private dom: DomSanitizer,
		private configService: ConfigService
	) {
		let self = this;

		this.cdnUrl = configService.get('cdn_url');
		this.sectionIntro = configService.get('intro_text');
		this.systemTitle = configService.get('title');
		this.systemSlogan = configService.get('slogan');
		this.systemKey = configService.get('system_key');
		this.salesWebsite = configService.get('sales_website');

		self.authenticationService.data.subscribe(data => {
			if (Object.keys(data).length) {
				self.currentUser = data;
				self.frontType = this.currentUser['organisationFrontType'];

				self.setChapterContent();
				self.setSections();
				self.setContent();
			} else {
				self.currentUser = false;
				self.setSections();
				self.setContent();
			}

			if (self.currentUser.role === 'ADMIN' || self.currentUser.role === 'TEACHER') {
				self.banner = configService.get('banner_teacher');
			} else {
				self.banner = configService.get('banner_student');
			}
		});
	}

	getMaxLessonsPerCarouselItem() {
		let maxLessonsPerCarouselItem
		const screenWidth = window.innerWidth
		if ( screenWidth >= 992 ) {
			maxLessonsPerCarouselItem = 3
		} else if ( screenWidth >= 576 ) {
			maxLessonsPerCarouselItem = 2
		} else {
			maxLessonsPerCarouselItem = 1
		}
		 return maxLessonsPerCarouselItem
	}

	splitCarouselAtIndex(index) {
		const maxLessonsPerCarouselItem = this.getMaxLessonsPerCarouselItem()

		if (!this.highlightLessons || this.highlightLessons.length < 1) {
			return [];
		}
		if (index < 0 || index >= Math.ceil(this.highlightLessons.length / maxLessonsPerCarouselItem)) {
			return "Invalid index";
		}

		const startIndex = index * maxLessonsPerCarouselItem;
		const endIndex = Math.min(startIndex + maxLessonsPerCarouselItem, this.highlightLessons.length);
		return this.highlightLessons.slice(startIndex, endIndex);
	}

	getCarouselSize() {
		const maxLessonsPerCarouselItem = this.getMaxLessonsPerCarouselItem()

		if (!this.highlightLessons) {
			return 1;
		}
		if ((this.highlightLessons.length / maxLessonsPerCarouselItem) < 1) {
			return 1;
		}
		
		return Math.ceil(this.highlightLessons.length / maxLessonsPerCarouselItem);
	}

	showLogin() {
		this.appService.showLoginModal();
	}

	oldHoverColor = "";

	makeColorVibrant(rgbString) {
		// Extract RGB components
		const regex = /(\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})/;
		const matches = rgbString.match(regex);

		if (matches) {
			// Extract RGB values
			let red = parseInt(matches[1]);
			let green = parseInt(matches[2]);
			let blue = parseInt(matches[3]);

			// Increase the intensity of each color component
			red = Math.min(red * 1.1, 255);
			green = Math.min(green * 1.1, 255);
			blue = Math.min(blue * 1.1, 255);

			// Return the modified RGB string
			return `rgb(${red}, ${green}, ${blue})`;
		} else {
			// If the RGB string is invalid, return as is
			return rgbString;
		}
	}

	hoverButton(e, state) {
		if (state) {
			this.oldHoverColor = e.target.style.backgroundColor;
			e.target.style.backgroundColor = this.makeColorVibrant(e.target.style.backgroundColor);
		} else {
			e.target.style.backgroundColor = this.oldHoverColor;
		}
	}

	ngOnInit(): void {
		this.appService.navActive();
		this.appService.setPageTitle('');
		this.appService.setPageDescription('');

		let self = this;

		self.authenticationService.getCurrentUser();
		self.appService.setDefaultAuthor();
		self.appService.setDefaultMeta();
		this.introImage = this.configService.get('intro_image_url');
		
		self.setHighlightLessons();
	}

	setHighlightLessons() {
		let self = this;
		self.apiConnectionService.read('index/highlights').then((response) => {
			self.highlightLessons = response;
		});
	}

	embed(url) {
		if (this.youtubeEmbedSafeURL == null) {
			this.youtubeEmbedSafeURL = this.dom.bypassSecurityTrustResourceUrl(url);
		}
		return this.youtubeEmbedSafeURL;
	}

	setChapterContent() {
		let self = this;

		self.ngxLoader.start();
		self.apiConnectionService.read('pages/front').then((response) => {
			self.frontTypeChapter = response;
			self.ngxLoader.stop();
		});
	}

	setContent() {
		if (!this.fetchedContent) {
			this.fetchedContent = true;
			let self = this;

			self.ngxLoader.start();
			self.apiConnectionService.read('pages/home').then((response) => {
				self.highlight = self.dom.bypassSecurityTrustHtml(response['highlight']);
				self.introText = self.dom.bypassSecurityTrustHtml(response['introText']);



				this.electives = this.configService.get('top_sections');
				this.bottomExtra = this.configService.get('bottom_sections');

				// self.apiConnectionService.read('sections').then((sectionData: any) => {
				// 	this.electives = [];

				// 	for (let i = 0; i < sectionData.length; i++) {
				// 		if (sectionData[i].homeTop == "1") {
				// 			self.electives.push(sectionData[i]);
				// 		} else {
				// 			self.bottomExtra.push(sectionData[i]);
				// 		}
				// 	}

				// 	self.ngxLoader.stop();
				// });

				self.apiConnectionService.read('sections/choiceAssignments').then((data: any) => {
					for (let i = 0; i < data.length; i = i + (data.length / 4)) {
						const items = data.slice(i, i + (data.length / 4));
						this.choiceAssignments.push(items);
					}
				});

				self.ngxLoader.stop();
			});
		}
	}

	setSections() {
		let self = this;

		if (self.currentUser === false) {
			this.topSections = this.configService.get('top_sections');
			this.bottomSections = this.configService.get('bottom_sections');
			return;
		} else if (self.currentUser['role'] === 'TEACHER' || self.currentUser['role'] === 'ADMIN') {

			this.topSections = this.configService.get('top_sections');
			this.bottomSections = this.configService.get('bottom_sections');

			self.ngxLoader.start();
			self.apiConnectionService.read('sections').then((response: any) => {
				for (let i = 0; i < response.length; i++) {
					const id = response[i].id;

					for (let i2 = 0; i2 < self.topSections.length; i2++) {
						const id2 = self.topSections[i2].id;

						if (id == id2 && !self.activeChapterIds.includes(id2)) {
							self.activeChapterIds.push(id2);
						}
					}
				}

				self.checkLicense = true;
				self.topSectionsIsLoaded = true;
				self.ngxLoader.stop();
			});
		} else {
			self.ngxLoader.start();
			self.apiConnectionService.read('sections').then((response) => {

				self.topSections = [];
				self.bottomSections = [];

				let collection: any = response;

				for (let key in collection) {
					if (collection[key]['homeTop'] == 1) {
						self.topSections.push(collection[key]);
					}
					if (collection[key]['homeBottom'] == 1) {
						self.bottomSections.push(collection[key]);
					}
				}

				self.topSectionsIsLoaded = true;
				self.ngxLoader.stop();
			});
		}
	}

	text(lesson) {
		return this.dom.bypassSecurityTrustHtml(lesson);
	}
}
